import React, {Component} from 'react';
import {FixedAspectRatioDiv} from '@rcm/fixed-aspect-ratio-div-react';
import PlayerIFrame from './PlayerIFrame';
import './PreviewPlayer.css';

interface PreviewPlayerProps {
    videoId: string;
    aspectRatio: string;
    onClick: (event) => void;
}

export default class PreviewPlayer extends Component<PreviewPlayerProps> {
    public render() {
        return <FixedAspectRatioDiv aspectRatio={this.props.aspectRatio}>
            <div className="vimeo-popup-player-preview-aspect-wrapper">
                <PlayerIFrame videoId={this.props.videoId} mode="background"/>
                <a onClick={this.props.onClick} className="vimeo-popup-player-link-overlay"/>
            </div>
        </FixedAspectRatioDiv>;
    }
}
